var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"id":"spectrum"}},[_c('polygon',{attrs:{"x":"0","y":"0","points":_vm.points}})])
}
var staticRenderFns = []

export { render, staticRenderFns }